





























































import { Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { ISideBar, IUser } from '@/types/types';
import { Getter, namespace } from 'vuex-class';
const authModule = namespace('auth');
@Component({
  name: 'SideBarDrawer',
})
export default class SideBarDrawer extends Vue {
  /**
   * Mirrors SideBar: Vue Router's active class is an inclusive match, so a link
   * like /payments would stay highlighted on /payments/callbacks.
   */
  get parentLinkNames(): string[] {
    const paths = (this.links || [])
      .filter((item: any) => item && item.link)
      .map((item: any) => {
        try {
          return { name: item.link, path: this.$router.resolve({ name: item.link }).route.path };
        } catch (e) {
          return null;
        }
      })
      .filter(Boolean) as Array<{ name: string; path: string }>;

    return paths
      .filter(
        ({ path }) =>
          // "/" prefixes every route, so unresolved (locked) links would other-
          // wise render permanently active.
          path === '/' || paths.some(other => other.path !== path && other.path.startsWith(`${path}/`)),
      )
      .map(({ name }) => name);
  }

  isParentOfAnotherLink(name: string): boolean {
    return this.parentLinkNames.includes(name);
  }

  @Prop({ required: false, default: false }) drawer!: boolean;
  @Getter('getNavigationDrawerState') drawerState!: boolean;
  @authModule.Getter('getUserDetails') user!: IUser;
  @Prop({ required: true, default: () => [] }) links!: ISideBar[];

  get initials(): string {
    const name = (this.user && this.user.name) || '';
    const parts = name
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) return 'KA';
    return parts
      .slice(0, 2)
      .map(part => part[0].toUpperCase())
      .join('');
  }

  // @Emit("closeOnOutsideClick")
  closeOnOutsideClick(payload: boolean) {
    this.$store.dispatch('navigationDrawer', payload, { root: true });
  }

  @Watch('drawerState')
  onDrawerChange(value: boolean) {}
}
